import { render, staticRenderFns } from "./sideBar.vue?vue&type=template&id=dbcd8e1e&"
import script from "./sideBar.vue?vue&type=script&lang=js&"
export * from "./sideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QImg,QItemLabel,QItem,QItemSection,QAvatar,QExpansionItem,QIcon,Ripple} from 'quasar'
component.options.components = Object.assign({QList,QImg,QItemLabel,QItem,QItemSection,QAvatar,QExpansionItem,QIcon}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
